import { PATH } from '@/constants/path';
import userPlans from '@/hooks/userPlans';
import { handleStateBanner, initialStateBanner } from '@/redux/slice/banner.slice';
import { Banner, Collapsible } from '@shopify/polaris';
import { capitalize } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface BannerLimitProps {
  isOpenBanner: boolean;
  children: React.ReactNode;
  keyBanner: keyof typeof initialStateBanner;
}

const BannerLimit: React.FC<BannerLimitProps> = ({ isOpenBanner, children, keyBanner }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { appPlanCurrent } = userPlans();
  const { t } = useTranslation('common');

  return (
    <Collapsible open={isOpenBanner} transition={{ duration: '300ms' }} id="">
      <Banner
        title={t('app_plan_current_limit', { appPlanCurrent: capitalize(appPlanCurrent) })}
        onDismiss={() => dispatch(handleStateBanner({ key: keyBanner, value: false }))}
        action={{
          content: t('increase_limit'),
          onAction: () => navigate(PATH.PRICING_PLAN),
        }}
      >
        {children}
      </Banner>
    </Collapsible>
  );
};

export default BannerLimit;
